import { motion } from "framer-motion";
void motion;
import { API_URL } from "../../env";
import SmartImage from "../components/ui/SmartImage";

// Wraps the first occurrence of `query` inside `text` in a <mark>, so when
// search results are sorted by relevance it's visually obvious why a card
// is ranked where it is.
const highlightMatch = (text, query) => {
  if (!query || !text) return text;

  const idx = text.toLowerCase().indexOf(query.toLowerCase());
  if (idx === -1) return text;

  return (
    <>
      {text.slice(0, idx)}
      <mark className="rounded-sm bg-blue-100 px-0.5 text-blue-900">
        {text.slice(idx, idx + query.length)}
      </mark>
      {text.slice(idx + query.length)}
    </>
  );
};

const ProductCard = ({ product, index, query, onViewDetails, onEnquire }) => {
  const imgUrl = `${API_URL}${product.image}`;
  const typeCount = product.listOfProducts?.length ?? 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.4, delay: Math.min(index, 6) * 0.04, ease: "easeOut" }}
      className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
    >
      <button
        type="button"
        onClick={() => onViewDetails(product)}
        aria-label={`View details for ${product.title}`}
        className="relative block h-48 w-full shrink-0 overflow-hidden text-left"
      >
        <SmartImage
          src={imgUrl}
          alt={product.title}
          wrapperClassName="h-full w-full"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading={index < 4 ? "eager" : "lazy"}
        />
        <div className="pointer-events-none absolute inset-0 bg-linear-to-t from-black/25 via-transparent to-transparent" />
        {typeCount > 0 && (
          <span className="absolute right-3 top-3 rounded-full border border-white/25 bg-slate-900/70 px-2.5 py-1 text-[11px] font-semibold text-white backdrop-blur-sm">
            {typeCount} Type{typeCount === 1 ? "" : "s"}
          </span>
        )}
      </button>

      <div className="flex flex-1 flex-col p-5">
        <h4
          className="text-base font-bold text-slate-900 md:text-lg"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          {highlightMatch(product.title, query)}
        </h4>
        <p className="mt-1 text-xs font-semibold text-blue-600 md:text-sm">
          {product.description}
        </p>
        <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-slate-500 md:text-sm">
          {product.detailedDescription}
        </p>

        <div className="mt-4 flex items-center gap-2">
          <button
            type="button"
            onClick={() => onViewDetails(product)}
            className="flex-1 rounded-xl border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 transition-colors duration-200 hover:border-blue-400 hover:text-blue-600 md:text-sm"
          >
            View Details
          </button>
          <button
            type="button"
            onClick={() => onEnquire(product.title)}
            className="flex-1 rounded-xl bg-blue-600 px-3 py-2 text-xs font-semibold text-white shadow-sm shadow-blue-200 transition-colors duration-200 hover:bg-blue-700 md:text-sm"
          >
            Enquire
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;